import React, { useId, useMemo, useState, useEffect } from 'react'
import { createPortal } from 'react-dom'
import L from 'leaflet'
import { Marker } from 'react-leaflet'
import './enhanced-marker-styles.scss'

type Props = {
  icon: React.ReactNode;
} & Omit<React.ComponentProps<typeof Marker>, 'icon'>;

const EnhancedMarker: React.FC<Props> = ({
  icon: providedIcon,
  ...otherProps
}) => {
  const [iconTarget, setIconTarget] = useState<HTMLElement | null>(null)
  const id = "marker-" + useId()

  const icon = useMemo(
    () =>
      L.divIcon({
        html: `<div id="${id}"></div>`,
        className: '',
      }),
    [id]
  )

  useEffect(() => {
    if (iconTarget !== null) return
    const el = document.getElementById(id)
    if (el) setIconTarget(el)
  }, [iconTarget, id])

  const memoizedHandlers = useMemo(() => ({
    add: () => setIconTarget(document.getElementById(id)),
    remove: () => setIconTarget(null),
  }), [id])

  return (
    <>
      <Marker
        {...otherProps}
        eventHandlers={memoizedHandlers}
        icon={icon}
      />
      {iconTarget && createPortal(providedIcon, iconTarget)}
    </>
  )
}

export default EnhancedMarker
